import {createNotificationStore} from './store'
import type {AddNotification, CustomNotification, NotificationType} from './types'

const store = createNotificationStore()

// Общая очередь работает только в браузере, чтобы сообщения не сохранялись между SSR-запросами.
const add: AddNotification = (msg, config) => {
  if (typeof window === 'undefined') return

  store.add(msg, config)
}

type NotificationOptions = Pick<CustomNotification, 'action' | 'duration'>

const withType = (type: NotificationType) => (msg: Parameters<AddNotification>[0], config?: NotificationOptions) => {
  add(msg, {...config, type})
}

export const notification = {
  add,
  clear: store.clear,
  error: withType('error'),
  info: withType('info'),
  remove: store.remove,
  store: {...store, add},
  success: withType('success'),
}
